import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearRightUpperControlArmProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearRightUpperControlArm(props: RearRightUpperControlArmProps) {
  return (
    <svg
      width="66"
      height="48"
      viewBox="0 0 66 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 86, right: 269}}
      onClick={props.onClick}
    >
      <path
        d="M37.0001 1V7.68555C41.6604 9.33313 45.0001 13.7754 45.0001 19C45.0001 20.9562 44.5316 22.8029 43.7013 24.4346L63.0001 47H53.0001L38.0001 29.9121C36.4238 30.6735 34.868 31 33.0001 31C31.2157 31 29.5222 30.6107 28.0001 29.9121L13.0001 47H3.00012L22.2697 24.3779C21.4574 22.7604 21.0001 20.9334 21.0001 19C21.0001 13.7754 24.3398 9.33313 29.0001 7.68555V1H37.0001Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M37.0001 7V1H29.0001V7"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M53.0001 46.9997L38.0001 29.9118C36.4237 30.6732 34.8681 31 33.0001 31C31.2157 31 29.5222 30.6105 28.0001 29.9119L13.0001 46.9998L3.00012 47L22.2696 24.3776C21.4573 22.76 21.0001 20.9334 21.0001 19C21.0001 12.3726 26.3727 7 33.0001 7C39.6275 7 45.0001 12.3726 45.0001 19C45.0001 20.9562 44.532 22.8031 43.7017 24.4348L63.0001 46.9997H53.0001Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M41.0001 19L37.0001 25.9282L29.0001 25.9282L25.0001 19L29.0001 12.0718L37.0001 12.0718L41.0001 19Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="33.0001"
        cy="19"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
